import { Routes, Route } from 'react-router-dom'
import { Navbar } from '@/components/navbar'
import HomePage from './pages/HomePage'
import AboutPage from './pages/AboutPage'
import CategoriesPage from './pages/CategoriesPage'
import ContactPage from './pages/ContactPage'
import ProvidersPage from './pages/ProvidersPage'
import SupportPage from './pages/SupportPage'
import TermsPage from './pages/TermsPage'

function App() {
  return (
    <div className="min-h-screen antialiased">
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/categories" element={<CategoriesPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/providers" element={<ProvidersPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/terms" element={<TermsPage />} />
      </Routes>
    </div>
  )
}

export default App

